<template>
  <div>
    <div v-if="!expired" class="login">
      <div class="title">{{ $t('createYourPassword') }}</div>

      <div class="info">
        {{ $t('userLogin.passwordRules') }}
      </div>

      <VeeForm v-slot="{ errors }" @submit="register">
        <Transition name="fade">
          <div v-if="Object.keys(errors).length > 0" class="error-container">
            <div class="error-icon">!</div>
            <div v-if="error" class="error-text">{{ error }}</div>
            <div v-else-if="errors['password']" class="error-text">{{ $t('errorMessage.passwordInvalid') }}</div>
            <div v-else-if="errors['passwordConfirmation']" class="error-text">{{ $t('errorMessage.passwordNotIdentical') }}</div>
          </div>
        </Transition>

        <div class="input-container">
          <div class="label-container">
            <div class="label">{{ $t('createYourPassword') }}</div>
            <div class="show-container" @click="showPassword = !showPassword">
              <div class="show-icon" :class="{ active: showPassword }"></div>
              <div class="show-text">{{ showPassword ? $t('hide') : $t('show') }}</div>
            </div>
          </div>

          <Field
            name="password"
            :rules="{
              required: true,
              regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/,
            }"
            :type="showPassword ? 'text' : 'password'"
            :placeholder="$t('password')"
          />
        </div>

        <div class="input-container">
          <div class="label-container">
            <div class="label">{{ $t('confirmation') }}</div>
            <div class="show-container" @click="showPassword = !showPassword">
              <div class="show-icon" :class="{ active: showPassword }"></div>
              <div class="show-text">{{ showPassword ? $t('hide') : $t('show') }}</div>
            </div>
          </div>

          <Field name="passwordConfirmation" rules="confirmed:@password" :type="showPassword ? 'text' : 'password'" :placeholder="$t('passwordConfirmation')" />
        </div>

        <button class="study-button main" :class="{ loading: loading }">
          {{ loading ? $t('loading') : $t('validate') }}
        </button>
      </VeeForm>
    </div>

    <div v-if="expired">
      <div class="title">{{ $t('creationLinkExpired') }}</div>
    </div>
  </div>
</template>

<script>
import { Field, Form as VeeForm } from 'vee-validate';

export default {
  components: {
    Field,
    VeeForm,
  },

  data() {
    return {
      showPassword: false,
      error: null,
      loading: false,
      expired: false,
    };
  },

  created() {
    this.$store
      .dispatch('clientRegisterCheck', this.$route.params.emailKey)
      .then(() => {
        this.expired = false;
      })
      .catch(() => {
        this.expired = true;
      });
  },

  methods: {
    register(values) {
      if (this.loading) return;
      this.loading = true;
      this.error = null;

      const studyId = this.$route.query.studyId;
      const userInfo = {
        password: values.password,
      };

      this.$store
        .dispatch('setClientRegisterInfo', { emailKey: this.$route.params.emailKey, studyId, userInfo })
        .then(() => {
          this.loading = false;

          if (studyId) {
            this.$router.push({
              name: 'userRegisterSecretQuestion',
              params: { emailKey: this.$route.params.emailKey },
              query: { studyId },
            });
          } else {
            this.$router.push({
              name: 'userRegisterSecretQuestion',
              params: { emailKey: this.$route.params.emailKey },
            });
          }
        })
        .catch(e => {
          this.loading = false;
          switch (e.code) {
            default:
              this.error = e.error;
              break;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
@use '@/styles/register.scss';
</style>
